<script setup lang="ts">
/**
 * FooterLinkList — 푸터 링크 컬럼 1개의 목록(<ul>) 렌더.
 *
 * AppFooter 가 같은 목록을 두 번 그린다(md+ 정적 컬럼 / <md 아코디언 — 브레이크포인트를 JS 로 판정하면
 * SSG 프리렌더(서버 폭 0=모바일)와 데스크톱 hydration 이 어긋나므로 두 마크업을 모두 내고 CSS 로 가른다).
 * 링크 종류 판정(라우트 링크 vs 홈 섹션 스크롤 버튼)이 두 곳에서 갈라지지 않도록 여기 한 곳에 둔다.
 */
import { RouterLink } from 'vue-router';

import { useScrollTo } from '#/composables/useScrollTo';
import { type FooterLink, isRouteLink } from '#/config/footerLinks';

interface Props {
  links: readonly FooterLink[];
  /** <li> 클래스 — 배치 컨텍스트(정적/아코디언)가 행 간격을 정한다. */
  itemClass?: string;
  /** 링크 클래스 — 배치 컨텍스트가 블록/인라인을 정한다. */
  linkClass?: string;
}

withDefaults(defineProps<Props>(), { itemClass: '', linkClass: '' });

const { goToSection } = useScrollTo();
</script>

<template>
  <ul class="m-0 list-none p-0">
    <li v-for="link in links" :key="link.label" :class="itemClass">
      <RouterLink v-if="isRouteLink(link)" :to="link.to" :class="linkClass">
        {{ link.label }}
      </RouterLink>
      <button v-else type="button" :class="linkClass" @click="goToSection('/', link.hash)">
        {{ link.label }}
      </button>
    </li>
  </ul>
</template>
